






















import Vue from 'vue';
import {Component,Prop} from 'vue-property-decorator';

@Component
export default class NumberPad extends Vue{
  @Prop(Number) readonly value!: number;
  output =this.value.toString();
  inputContent(event:MouseEvent){
    const button = event.target as HTMLButtonElement;
    const input = button.textContent as string;//防止提示input为空的错误情况，as xx也可以用!代替
    if(this.output.length === 16){ return; }
    if(this.output=== '0'){
      if(('1234567890').indexOf(input)>=0){
        this.output = input;
      }else{
        this.output+=input;
      }
      return;
    }
    if(this.output.indexOf('.')>=0 && input==='.'){return;}
    this.output +=input;
  }
  remove(){
   
    if(this.output.length===1){
      this.output = '0';
    }else{
      this.output =this.output.substring(0,-1);
    }
  }
  ok(){
    const number = parseFloat(this.output);
    if(number !== 0){
      this.$emit('update:value', number);
      this.$emit('submit', number);
    }
    this.output ='0';
  }
  clear(){
    this.output = '0';
  }
}
